import {
  DATA_CONNECTOR_CREATE_COLLECTION_WITH_MY_SQL_BEGIN,
  DATA_CONNECTOR_CREATE_COLLECTION_WITH_MY_SQL_SUCCESS,
  DATA_CONNECTOR_CREATE_COLLECTION_WITH_MY_SQL_FAILURE,
  DATA_CONNECTOR_CREATE_COLLECTION_WITH_MY_SQL_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function createCollectionWithMySql(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_CREATE_COLLECTION_WITH_MY_SQL_BEGIN,
    });

    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/mysql/create-collection`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_CREATE_COLLECTION_WITH_MY_SQL_SUCCESS,
            data: res,
          });
          Mixpanel.track('Created Collection from MySQL data source', {
            uuid: res.data.uuid,
            collectionName: res.data.collectionName,
          });
          toast.success('Collection created successfully!');
          resolve(res);
        },
        (err) => {
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          Mixpanel.track('Failed to create collection from MySQL data source');
          dispatch({
            type: DATA_CONNECTOR_CREATE_COLLECTION_WITH_MY_SQL_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissCreateCollectionWithMySqlError() {
  return {
    type: DATA_CONNECTOR_CREATE_COLLECTION_WITH_MY_SQL_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_CREATE_COLLECTION_WITH_MY_SQL_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        createCollectionWithMySqlPending: true,
        createCollectionWithMySqlError: null,
      };

    case DATA_CONNECTOR_CREATE_COLLECTION_WITH_MY_SQL_SUCCESS:
      // The request is success
      return {
        ...state,
        createCollectionWithMySqlPending: false,
        createCollectionWithMySqlError: null,
      };

    case DATA_CONNECTOR_CREATE_COLLECTION_WITH_MY_SQL_FAILURE:
      // The request is failed
      return {
        ...state,
        createCollectionWithMySqlPending: false,
        createCollectionWithMySqlError: action.data.error,
      };

    case DATA_CONNECTOR_CREATE_COLLECTION_WITH_MY_SQL_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        createCollectionWithMySqlError: null,
      };

    default:
      return state;
  }
}
